import styled from "styled-components";

export const Row = styled.div<{ $on: boolean }>`
  display: flex;
  gap: 12px;
  padding: 13px 14px;
  border-radius: 16px;
  align-items: center;
  font-family: ${(p) => p.theme.tokens.font.family};
  background: ${(p) => (p.$on ? "#F1FAF5" : p.theme.tokens.colors.surface)};
  border: 1.5px solid ${(p) => (p.$on ? "#BCE9D3" : p.theme.tokens.colors.line)};
  transition: all 0.15s;

  & + & {
    margin-top: 9px;
  }
`;

export const PhotoWrap = styled.div`
  width: 56px;
  height: 56px;
  flex-shrink: 0;
`;

export const Texts = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Desc = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  line-height: 1.35;
  margin-top: 3px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PriceLabel = styled.div`
  font-weight: 800;
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.teal};
  margin-top: 5px;
`;
